import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LoginIcon from '@mui/icons-material/Login';

const DrawerContent = ({ toggleDrawer }) => (
  <Box
    sx={{ width: 250 }}
    role="presentation"
    onClick={toggleDrawer(false)}
    onKeyDown={toggleDrawer(false)}
  >
    <List>
      <ListItem key={'item'} disablePadding>
        <ListItemButton to="/upload">
          <ListItemIcon>
            <AddCircleIcon />
          </ListItemIcon>
          <ListItemText primary={'아이템 등록'} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton to="/trade">
          <ListItemIcon>
            <ThumbsUpDownIcon />
          </ListItemIcon>
          <ListItemText primary={'거래'} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton to="/my">
          <ListItemIcon>
            <ListAltIcon />
          </ListItemIcon>
          <ListItemText primary={'내 아이템'} />
        </ListItemButton>
      </ListItem>
    </List>
    <Divider />
    <List>
      <ListItem key={'login'} disablePadding>
        <ListItemButton to="/login">
          <ListItemIcon>
            <LoginIcon />
          </ListItemIcon>
          <ListItemText primary={'login'} />
        </ListItemButton>
      </ListItem>
    </List>
  </Box>
);

export default DrawerContent;
